import { computed, ref } from 'vue'
import {
    getEmployeeHistory,
    getEmployeeActivities,
    block,
    createEmployee,
    getAvailableRoles,
    getEmployees,
    getSingleEmployee,
    givePassword,
    unblock,
    updateEmployee
} from './api'

import { AvailableRoles, EmployeeModel } from './types'

export * from './types'

const employees = ref<EmployeeModel[]>([])
const availableRoles = ref<AvailableRoles>([])

const loadEmployees = () => getEmployees().then(newEmployees => {
    employees.value = newEmployees
})
const loadAvailableRoles = () => getAvailableRoles().then(roles => {
    availableRoles.value = roles
})

export function useEmployeeModule () {
    return {
        loadEmployees,
        loadAvailableRoles,
        givePassword,
        createEmployee,
        updateEmployee,
        getSingleEmployee,
        getEmployeeHistory,
        getEmployeeActivities,
        block,
        unblock,
        employees: computed(() => employees.value),
        availableRoles: computed(() => availableRoles.value)
    }
}
